<template>
  <div id="productDetail">
    <NavigationBar />
    <!-- <div class="uk-section" 
				id="topBanner" 
				:style="{ backgroundImage: `url(${ banner })` }" >
			<div class="uk-container">
				<div class="uk-flex uk-flex-center uk-flex-middle uk-height-medium uk-height-max-small" uk-grid>
					<div class="uk-text-center">
						<p class="uk-text-large uk-text-capitalize" uk-scrollspy="cls: uk-animation-slide-top; delay: 500; repeat: true;">{{ category}}</p>
						<p class="uk-heading-small uk-text-bold uk-margin-remove uk-text-capitalize" uk-scrollspy="cls: uk-animation-slide-bottom; delay: 500; repeat: true;">{{ product }}</p>
					</div>
				</div>
			</div>
		</div> -->
    <div v-if="!loading">
      <div class="uk-section">
        <div class="uk-container">
          <div class="uk-grid" uk-grid>
            <div class="uk-width-1-2@s">
              <div uk-scrollspy="cls: uk-animation-scale-up; delay: 300; repeat: true;" class="uk-position-relative" uk-slideshow="autoplay: true">
                <div class="uk-slideshow-items slider-contact">
                  <div>
                    <img :src="data.thumbnail" alt="" uk-cover>
                    <div class="uk-position-bottom uk-animation-slide-bottom uk-margin-medium-bottom flex flex-center uk-text-center uk-margin-medium-left uk-margin-medium-right">
                    </div>
                  </div>
                </div>
                <ul class="uk-slideshow-nav uk-dotnav uk-flex-center uk-margin" uk-slideshow-nav></ul>
                <a class="uk-position-center-left uk-position-small uk-hidden-hover" href="#" uk-slidenav-previous uk-slideshow-item="previous"></a>
                <a class="uk-position-center-right uk-position-small uk-hidden-hover" href="#" uk-slidenav-next uk-slideshow-item="next"></a>
              </div>
            </div>
            <div class="uk-width-1-2@s">
              <div class="uk-child-width-1-1 uk-text-left" uk-grid>
                <br>
                <ul class="uk-list uk-margin-remove-top">
                    <li><p class="uk-text-bold font-sub-head uk-text-uppercase">{{ this.product }}</p></li>
                    <li><h3><b>{{ formatRupiah(data.price) }}</b></h3></li>
                </ul>
                <!-- <div class="uk-margin">
                    <input class="uk-input uk-form-width-small" type="text" placeholder="1" aria-label="Small" style="margin-right: 10px"> 
                    <button class="uk-button uk-button-secondary">Add To Cart</button>
                </div> -->
                <!-- <p class="font-description">Advanced Security, Easy to Use, Perfect for Smart Homes.</p> -->
                <p class="font-description">Category : <button @click="openCategory(data.categories.seo_url)" class="uk-text-primary uk-text-bold uk-button uk-button-link font-description uk-text-capitalize">{{ data.categories.name }}</button></p>
                <p class="font-sub-head uk-text-bold">Description</p>
                <p class="uk-margin-small-top font-description">{{ data.description }}</p>
                <div v-if="files != ''">
                  <p class="font-sub-head uk-text-bold uk-margin-remove-bottom">Downloads</p>
                  <table class="uk-margin-remove-top uk-table uk-table-striped uk-hover">
                    <thead>
                      <tr>
                        <th><b>Filename</b></th>
                        <th><b>Version</b></th>
                        <th><b>Option</b></th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="file in files" :key="file.name">
                        <td>{{ file.name }}</td>
                        <td>{{ file.version }}</td>
                        <td>
                          <a
                            :href="file.url_download"
                            target="_blank"
                            >Download</a
                          >
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                  <!-- <div>
                      <div class="uk-card uk-card-primary uk-card-body">Item</div>
                  </div> -->
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- <div class="uk-section uk-padding-remove-top">
        <div class="uk-container">
          <div class="uk-visible@s uk-grid uk-grid-match" uk-grid>
            <div class="uk-text-center uk-width-1-4@s" v-for="event in influencerData">
              <div class="uk-flex-middle cursor uk-box-shadow-large uk-grid-collapse" uk-grid>
                <div class="">
                  <iframe style="width: 100%; height: 400px;"
                    :src="event.src"
                    frameborder="0"
                    allow="autoplay; encrypted-media"
                    allowfullscreen
                  ></iframe>
                </div>
              </div>
            </div>
          </div>  
        </div>
      </div> -->

      <div class="uk-section uk-padding-remove-top">
        <div class="uk-container">
          <div uk-grid>
            <div class="uk-width-1-2@s">
              <p class="font-sub-head uk-text-bold uk-margin-remove-bottom">Specifications</p>
              <table v-if="data.specifications != ''" class="uk-table uk-table-justify uk-table-divider">
                <thead></thead>
                <tbody>
                    <tr v-for="item in data.specifications">
                        <td class="uk-text-bold">{{ item.name }}</td>
                        <td>{{ item.value }}</td>
                    </tr>
                </tbody>
              </table>
              <p class="uk-text-muted" v-else>Data not available</p>
            </div>
            <div class="uk-width-1-2@s">
              <div v-if="videos != ''">
                <div v-for="video in videos" :key="video.url">                  
                  <iframe style="width: 100%; height: 400px;"
                    :src="video.url"
                    frameborder="0"
                    allow="autoplay; encrypted-media"
                    allowfullscreen
                  ></iframe>
                </div>
              </div>
              <p class="font-sub-head uk-text-bold">Features</p>
              <div v-if="data.features != ''" class="uk-grid uk-grid-match" uk-grid>
                <div class="uk-width-1-2@m">
                  <ul class="uk-list uk-list-disc">
                    <li v-for="(item, index) in leftList" :key="index">{{ item.name }}</li>
                  </ul>
                </div>
                <div class="uk-width-1-2@m">
                  <ul class="uk-list uk-list-disc">
                    <li v-for="(item, index) in rightList" :key="index">{{ item.name }}</li>
                  </ul>
                </div>
              </div>
              <p class="uk-text-muted" v-else>Data not available</p>
            </div>
          </div>
        </div>
      </div>
  
      <div class="uk-section uk-padding-remove-top">
        <div class="uk-container">
          <p class="font-sub-head uk-text-bold">Related Products</p>
          <div v-if="dataRelated != ''" class="uk-slider uk-slider-container" uk-slider="autoplay: true; autoplay-interval: 3000">
            <div class="uk-position-relative">
                <ul class="uk-slider-items uk-grid uk-child-width-1-5@s">
                    <li v-for="product in dataRelated">
                        <div @click="openProduct(product.seo_url)" class="cursor uk-card uk-card-default uk-background-primary">
                            <div class="uk-card-media-top">
                                <img :src="product.thumbnail" width="1800" height="1200" :alt="product.thumbnail">
                            </div>
                            <div class="uk-card-body uk-padding-remove">
                                <div class="uk-margin-top uk-margin-bottom uk-margin-left uk-margin-right">
                                    <p class="font-white">{{ product.name }}</p>
                                </div>
                            </div>
                        </div>
                    </li>
                </ul>
                <a class="uk-position-center-left uk-position-small" href="#" uk-slider-item="previous">
                    <span uk-slidenav-previous></span>
                </a>
                <a class="uk-position-center-right uk-position-small" href="#" uk-slider-item="next">
                    <span uk-slidenav-next></span>
                </a>
            </div>
        </div>
          <p class="uk-text-muted" v-else>Data not available</p>
        </div>
      </div>
    </div>

    <div v-else class="uk-section" style="height: 70vh">
        <div class="uk-container" style="height: 100%">
          <div
            class="uk-flex uk-flex-center uk-flex-middle"
            style="height: 100%"
          >
            <div uk-spinner></div>
          </div>
        </div>
      </div>
    <h1 class="uk-heading-divider"></h1>
    <Footer />
  </div>
</template>

<script>
import NavigationBar from "@/components/NavigationBar.vue";
import Footer from "@/components/Footer.vue";
import NavbarMobileComponent from "@/components/NavbarMobileComponent.vue";
import VueCompareImage from "vue-compare-image";
import axios from "axios";
import { mapGetters } from "vuex";

export default {
  name: "productView",
  props: {
    categoryid: String,
    productid: String
  },
  components: {
    NavigationBar,
    Footer,
    NavbarMobileComponent,
    VueCompareImage,
  },
  data() {
    return {
      data: {},
      dataRelated: {},
      banner: require('../../assets/woman-in-white-blazer-holding-tablet-computer-789822EDIT.jpg'),
      loading: true,
      category: '',
      product: '',
      category_link: '',
      files: [],
      videos: [],
    };
  },
  computed: {
    ...mapGetters("auth", ["IS_AUTH", "GET_USER"]),
    isSmall() {
      return window.innerWidth < 960;
    },
    isVerySmall() {
      return window.innerWidth < 640;
    },
    midpoint() {
      return Math.ceil(this.data.features.length / 2);
    },
    leftList() {
      return this.data.features.slice(0, this.midpoint);
    },
    rightList() {
      return this.data.features.slice(this.midpoint);
    }
  },
  watch: {
    categoryid: {
      immediate: true,
      handler(newVal) {
        this.category_link = newVal
        this.category = this.replaceDashWithSpace(newVal)
      }
    },
    productid: {
      immediate: true,
      handler(newVal) {
        this.product = this.replaceDashWithSpace(newVal)
        this.getProduct()
        this.getFiles()
        this.getVideos()
      }
    }
    // '$route.params.productId': function(newId) {
    //   this.product = this.replaceDashWithSpace(newId);
    // },
    // '$route.params.categoryId': function(newId) {
    //   this.category_link = newId
    //   this.category = this.replaceDashWithSpace(newId);
    // }
  },
  mounted() {
    this.category_link = this.categoryid
    this.product = this.replaceDashWithSpace(this.productid)
    this.category = this.replaceDashWithSpace(this.categoryid)
    this.getProduct()
    this.getFiles()
    this.getVideos()
  },
  methods: {
    replaceDashWithSpace(str) {
      return str.replace(/-/g, ' ');
    },
    replaceSpaceWithDash(str) {
      return str.replace(/\s+/g, "-");
    },
    getProduct() {
      this.loading = true;
      axios
        .get(
          `${process.env.VUE_APP_API_ROOMI_URL}product/detail/${this.productid}`
        )
        .then((res) => {
          if (res.status == 200) {
            const data = res.data;
            this.data = data.data;
            this.getRelatedProduct(this.data.product_category_id)
            // this.data.image = this.encodeURI(`http://192.168.0.103:3000/images/${this.data.thumbnail}`)
            this.setSeo();
            this.loading = false;
          } else {
            this.$router.push("/not-found");
          }
        })
        .catch((err) => {
          this.$router.push("/not-found");
        });
    },
    getRelatedProduct(category) {
      axios
        .get(
          `${process.env.VUE_APP_API_ROOMI_URL}product/related/${category}/${this.productid}`
        )
        .then((res) => {
          if (res.status == 200) {
            const data = res.data;
            this.dataRelated = data.data;
            // this.dataRelated.image = this.encodeURI(`http://192.168.0.103:3000/images/${this.data.thumbnail}`)
            this.setSeo();
          } else {
            // this.$router.push("/not-found");
          }
        })
        .catch((err) => {
          // this.$router.push("/not-found");
        });
    },
    getFiles() {
      axios
        .get(
          `${process.env.VUE_APP_API_ROOMI_URL}product/file/${this.productid}`
        )
        .then((res) => {
          if (res.status == 200) {
            const data = res.data;
            this.files = data.data;
          } 
        })
        .catch((err) => {
          console.log('ERR', err)
        });
    },
    getVideos() {
      axios
        .get(
          `${process.env.VUE_APP_API_ROOMI_URL}product/video/${this.productid}`
        )
        .then((res) => {
          if (res.status == 200) {
            const data = res.data;
            this.videos = data.data;
          } 
        })
        .catch((err) => {
          console.log('ERR', err)
        });
    },
    setSeo() {
      let titlePage = this.data.name + " from Roomi";
      const siteDescription = this.data.description;
      document.title = titlePage;
      const check_meta = document.querySelectorAll("meta");
      let count_check = 0;
      check_meta.forEach((check) => {
        if (
          check.getAttribute("name") == "description" ||
          check.getAttribute("name") == "title" ||
          check.getAttribute("name") == "robots"
        ) {
          if (check.getAttribute("name") == "description") {
            check.setAttribute("content", "");
          }
          if (check.getAttribute("name") == "title") {
            check.setAttribute("content", titlePage);
          }
          if (check.getAttribute("name") == "robots") {
            check.setAttribute("content", "index, follow");
          }
          count_check = 1;
        }
      });
      if (count_check == 0) {
        var meta_description = document.createElement("meta");
        meta_description.setAttribute("name", "description");
        meta_description.setAttribute("content", siteDescription);
        document.getElementsByTagName("head")[0].appendChild(meta_description);
        const meta_title = document.createElement("meta");
        meta_title.setAttribute("name", "title");
        meta_title.setAttribute("content", titlePage);
        document.getElementsByTagName("head")[0].appendChild(meta_title);
        const meta_robots = document.createElement("meta");
        meta_robots.setAttribute("name", "robots");
        meta_robots.setAttribute("content", "index, follow");
        document.getElementsByTagName("head")[0].appendChild(meta_robots);
      }
    },
    openProduct(product){
			// this.$router.push({ name: 'Product Detail', params: { id: product } });
      this.$router.push({ name: 'product-detail', params: { categoryid: this.category_link, productid: this.replaceSpaceWithDash(product) } })
		},
    openCategory(category){
			this.$router.push({ name: 'category', params: { id: category } });
		},
    formatRupiah(value) {
      return `Rp ${value.toLocaleString('id-ID')}`;
    },
    encodeURI(url) {
      return encodeURI(url);
    },
  },
};
</script>

<style lang="less" scoped>
</style>